import React from 'react';
import { Box } from '@mui/material';

export const YOU_COLOR = '#EB7536';
export const PARTNERS_COLOR = '#546e7a';

/** You ● vs partners ● on one 0–100% track (share of days sold out), joined by a line. */
const DumbbellTrack = ({ you, partners, width = 160 }) => {
  const lo = Math.min(you, partners);
  const hi = Math.max(you, partners);
  const dot = (pct, color, label) => (
    <Box
      aria-label={label}
      sx={{
        position: 'absolute',
        left: `calc(${pct}% - 5px)`,
        width: 10,
        height: 10,
        borderRadius: '50%',
        bgcolor: color,
        border: '1px solid #fff',
      }}
    />
  );
  return (
    <Box sx={{ position: 'relative', width, height: 14, display: 'flex', alignItems: 'center', flexShrink: 0, minWidth: 0 }}>
      <Box sx={{ position: 'absolute', left: 0, right: 0, height: 4, borderRadius: 2, bgcolor: '#eceff1' }} />
      <Box sx={{ position: 'absolute', left: `${lo}%`, width: `${hi - lo}%`, height: 2, bgcolor: '#b0bec5' }} />
      {dot(partners, PARTNERS_COLOR, `Partners ${partners}%`)}
      {dot(you, YOU_COLOR, `You ${you}%`)}
    </Box>
  );
};

export default DumbbellTrack;
